import { useState, useEffect } from 'react'

const AmbassadorCard = ({ partnerStatus, loading, onRefresh }) => {
  const [daysRemaining, setDaysRemaining] = useState(null)

  useEffect(() => {
    if (!partnerStatus?.is_partner || !partnerStatus?.partner_expires_at) {
      setDaysRemaining(null); return
    }
    const updateCountdown = () => {
      const diff = new Date(partnerStatus.partner_expires_at) - new Date()
      setDaysRemaining(Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24))))
    }
    updateCountdown()
    const interval = setInterval(updateCountdown, 60 * 1000)
    return () => clearInterval(interval)
  }, [partnerStatus?.partner_expires_at, partnerStatus?.is_partner])

  if (loading) return null
  if (!partnerStatus?.is_partner) return null

  const commissionRate = (partnerStatus.commission_rate * 100).toFixed(0)
  const expiresDate = partnerStatus.partner_expires_at
    ? new Date(partnerStatus.partner_expires_at).toLocaleDateString('fr-FR', {
        day: 'numeric', month: 'long', year: 'numeric'
      })
    : '—'

  // Code couleur pour l'urgence (tons DNA)
  const urgency = daysRemaining !== null
    ? daysRemaining <= 7
      ? { text: '#a60d18', bg: '#faeded', border: 'rgba(120,0,0,.18)', label: 'Expire bientôt' }
      : daysRemaining <= 30
        ? { text: '#9a6610', bg: '#fdf3df', border: 'rgba(154,102,16,.22)', label: 'Contrat en cours' }
        : { text: '#128154', bg: '#eef7f1', border: '#d3eadd', label: 'Contrat actif' }
    : { text: 'var(--muted)', bg: '#fbf8f4', border: 'var(--line)', label: '—' }

  return (
    <div className="ambassador-card">
      <div className="ambassador-head">
        <span className="ambassador-icon"><i className="fa-solid fa-crown" /></span>
        <span className="ambassador-titles">
          <b>Ambassadeur <em>VIP</em></b>
          <span className="ambassador-pill">
            <i className="fa-solid fa-handshake" /> Partenaire Pass&apos;io
          </span>
        </span>
        {onRefresh && (
          <button className="icon-button ambassador-refresh" onClick={onRefresh} title="Rafraîchir" aria-label="Rafraîchir">
            <i className="fa-solid fa-rotate" />
          </button>
        )}
      </div>

      <div className="ambassador-stats">
        <div className="ambassador-stat is-green">
          <span>Commission</span>
          <strong>{commissionRate}%</strong>
          <small>sur chaque vente</small>
        </div>
        <div className="ambassador-stat" style={{ background: urgency.bg, borderColor: urgency.border }}>
          <span>Contrat</span>
          <strong style={{ color: urgency.text }}>{daysRemaining !== null ? `${daysRemaining}j` : '—'}</strong>
          <small style={{ color: urgency.text }}>{urgency.label}</small>
        </div>
      </div>

      <div className="ambassador-foot">
        <span>
          <i className="fa-regular fa-calendar" /> Expire le <strong>{expiresDate}</strong>
        </span>
        <span className="ambassador-vip">
          <i className="fa-solid fa-bolt" /> VIP
        </span>
      </div>
    </div>
  )
}

export default AmbassadorCard
